// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Income = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      d="M13.54 2.661v5.49M15.786 5.906 13.54 8.152l-2.246-2.246M4.55 14.397H2.024v-3.538H4.55M8.593 11.365h1.915l3.562-.8c1.285-.288 1.944.14 2.427 1.39l-3.355 1.431-4.043 1.011H4.55v-3.538L6.13 9.28a1.52 1.52 0 0 1 1.074-.442c1.183 0 4.422 1.263 4.422 1.263a1.263 1.263 0 0 1-1.264 1.264z"
    />
  </svg>
);
const ForwardRef = forwardRef(Income);
export default ForwardRef;
